/* global zzl, jQuery */
import DOM from '../zzl-lib/dom/dom'

const h = DOM.create

const slickOptions = {
	autoplay: true,
	autoplaySpeed: 1400,
	speed: 2000,
	fade: true,
	dots: true,
	pauseOnHover: false
}

function init () {
	if (!window.zzl || !zzl.env || !zzl.env.uploadImagePrefix) {
		console.warn('home-slide.js: Missing uploadImagePrefix config')
		return
	}

	const wrap = document.getElementById('slider')
	if (!wrap) return

	const imagesJson = wrap.getAttribute('data-images')
	if (!imagesJson) {
		console.warn('home-slide.js: Missing data-images attribtue')
		return
	}
	const images = JSON.parse(imagesJson)

	const prefix = zzl.env.uploadImagePrefix
	const itemsE = DOM.fragment(
		images.map(image => {
			const picture = h('picture', {}, [
				h('source', { media: '(max-width: 600px)', srcset: prefix.concat(image.src) }),
				h('source', { media: '(min-width: 601px)', srcset: prefix.concat(image.src_lg) }),
				h('img', { alt: image.title, src: prefix.concat(image.src_lg) })
			])
			const item = image.link_url ?
				h('a.slide-item', { href: image.link_url, target: image.link_target }, [picture]) :
				h('div.slide-item', {}, [picture])
			return item
		})
	)
	wrap.innerHTML = ''
	wrap.appendChild(itemsE)

	jQuery(wrap).slick(slickOptions)
}

init()
